"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = YoutubeSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function YoutubeSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "YouTube"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "youtube-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "youtube-square-2",
    "data-name": "youtube-square"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,67.258c-1.377,0-13.559-.028-17.051-.969a7.741,7.741,0,0,1-5.477-5.448c-.934-3.508-.961-10.073-.961-10.811s.027-7.3.961-10.812a7.782,7.782,0,0,1,5.478-5.507c3.491-.941,15.673-.969,17.05-.969s13.559.028,17.051.969a7.785,7.785,0,0,1,5.477,5.507h0c.934,3.509.961,10.075.961,10.812s-.027,7.3-.961,10.812a7.741,7.741,0,0,1-5.478,5.447C63.559,67.23,51.377,67.258,50,67.258Zm0-29.516c-4.948,0-13.6.217-15.75.8A2.772,2.772,0,0,0,32.3,40.5a51.217,51.217,0,0,0-.793,9.528,51.207,51.207,0,0,0,.793,9.527,2.7,2.7,0,0,0,1.946,1.9c2.151.58,10.8.8,15.75.8s13.6-.217,15.75-.8a2.7,2.7,0,0,0,1.946-1.9,51.093,51.093,0,0,0,.793-9.528A51.2,51.2,0,0,0,67.7,40.5h0a2.772,2.772,0,0,0-1.946-1.963C63.6,37.959,54.948,37.742,50,37.742Z"
  })), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "45.707 56.271 45.707 43.788 56.678 50.03 45.707 56.271 45.707 56.271"
  })))));
}